<template>
  <ToggleGroupRoot
    :type="type"
    :class="cn(groupVariants({ size }))"
    :disabled="disabled"
    :size="size"
    @update:modelValue="(value) => handleChange(value)"
  >
    <slot />
  </ToggleGroupRoot>
</template>

<script setup>
import { ToggleGroupRoot } from "radix-vue";
import { cn } from "@/Utils/cn";
import { sizes, groupVariants } from ".";
import { ref } from "vue";

const props = defineProps({
  size: {
    type: null,
    validator: (val) => sizes.includes(val),
    required: false,
    default: "sm",
  },
  type: { type: String, required: false, default: "multiple" },
  disabled: { type: Boolean, required: false, default: false },
});

const emit = defineEmits(["update:modelValue"]);
const selectedValue = ref(props.modelValue);

const handleChange = (value) => {
  selectedValue.value = value;
  emit("update:modelValue", value);
};
</script>
